<script>
  import Movimento from './Movimentos.svelte';

export let id;
  export let treino = {
    tipo: 'For Time',
    numero: '',
    tempo: '',
    detalhes: '',
    movimentos: []
  };

  const tipos = ['For Time', 'AMRAP', 'EMOM'];

  function adicionarMovimento() {
    treino.movimentos = [...treino.movimentos, { id: treino.movimentos.length, movimento: { nome: '', repetições: '' } }];
  }

  function removerMovimento() { 
    treino.movimentos = treino.movimentos.slice(0, -1);
  }
</script>

<div class="treino-container">
  <label for="tipo-{id}">Tipo do Treino:</label>
  <select id="tipo-{id}" bind:value={treino.tipo}>
    {#each tipos as tipo}
      <option value={tipo}>{tipo}</option>
    {/each}
  </select>

  <label for="tempo-{id}">Tempo:</label>
  <input type="time" id="tempo-{id}" step="1" bind:value={treino.tempo} />

  <label for="numero-{id}">Número de Rounds:</label>
  <input type="number" id="numero-{id}" bind:value={treino.numero} />

<label for="detalhes-{id}">Observações (cargas, variações, etc.):</label>
  <input type="text" id="detalhes-{id}" bind:value={treino.detalhes} />

  <div class="button-container">
    <button class="button-verde" on:click={adicionarMovimento}>Adicionar Movimento</button>
    <button class="button-vermelho" on:click={removerMovimento} disabled={treino.movimentos.length === 0}>Remover Movimento</button>
  </div>

  {#each treino.movimentos as movimento, index (movimento.id)}
    <Movimento id={movimento.id} bind:movimento={treino.movimentos[index].movimento} />
  {/each}
</div>

<style>
  .treino-container {
    border: 2px solid #000; /* Cor do contorno */
    border-radius: 8px; /* Bordas arredondadas */
    padding: 16px; /* Espaçamento interno */
    margin: 16px auto; /* Espaçamento superior e inferior de 16px, centralizado horizontalmente */
    max-width: 750px; /* Largura máxima de 500 pixels */
    width: 100%; /* Largura 100% para telas menores */
    box-sizing: border-box; /* Inclui padding e border na largura total */
  }

  label {
    display: block;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  input[type="text"],
  input[type="number"],
  input[type="time"],
  select {
    width: 100%; /* Ocupa toda a largura da div */
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  input[type="text"]:focus,
  input[type="number"]:focus,
  input[type="time"]:focus,
  select:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
  }

  input[type="text"]:disabled,
  input[type="number"]:disabled,
  input[type="time"]:disabled,
  select:disable {
    background-color: #f5f5f5;
    color: #aaa;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .button-verde {
    background-color: #03942e;
    color: white;
  }

  .button-vermelho {
    background-color: #e75f5f;
    color: white;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  button:not(:disabled):hover {
    /*background-color: #115293;*/
    color: rgb(190, 184, 184);
  }

  .button-container {
    margin: 16px 0; /* Espaçamento superior e inferior de 16px */
  }

  .button-container button {
    margin: 0 8px; /* Espaçamento lateral entre os botões */
  }
  .margem {
    margin-top: 70px;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 100px;
  }
</style>
